import { Modal, Button, Input } from "antd";

export function PackageMessageModal({
    messageText,
    setMessageText,
    onSend,
    onClose
}: {
    messageText: string;
    setMessageText: (text: string) => void;
    onSend: () => void;
    onClose: () => void;
}) {
    return (
        <Modal
            open={true}
            onCancel={onClose}
            title="Send Message"
            footer={[
                <Button key="send" type="primary" onClick={onSend}>
                    Send
                </Button>,
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>
            ]}
        >
            <Input.TextArea
                rows={4}
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
            />
        </Modal>
    );
}
